import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'utils/api';
import {
  setIsAuthenticated,
  setIsLoading,
  setSystemSelectorZoomUrl,
  setUser
} from './auth-slice';

export const checkUserAuth = createAsyncThunk(
  'auth/checkUserAuth',
  async (_, { dispatch }) => {
    dispatch(setIsLoading(true));
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_PARTNERNET_URL}/api/authentication/check-user`
      );
      if (response.status === 200 && response.data.userID) {
        dispatch(setIsAuthenticated(true));
        dispatch(setUser(response.data));
      } else {
        dispatch(setIsAuthenticated(false));
        dispatch(setUser(null));
      }
    } catch {
      dispatch(setIsAuthenticated(false));
      dispatch(setUser(null));
    } finally {
      dispatch(setIsLoading(false));
    }
  }
);

export const fetchSystemSelectorZoomUrl = createAsyncThunk(
  'auth/fetchSystemSelectorZoomUrl',
  async (_, { dispatch }) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_PARTNERNET_URL}/api/pnet/system-selector/zoom-url`
      );
      dispatch(
        setSystemSelectorZoomUrl(response.data.systemSelectorZoomURL ?? null)
      );
    } catch {
      dispatch(setSystemSelectorZoomUrl(null));
    }
  }
);
